document.addEventListener('DOMContentLoaded', () => {
  const articleHeaders = document.querySelectorAll('.js--toc_header');
  const offset = 90;
  const tocContainer = document.querySelector('.toc__list');
  const formFastRegistration = document.getElementById('formFastRegistration');

  if (tocContainer && formFastRegistration) {
    tocContainer.style.maxHeight = '30vh';
  }

  if (articleHeaders.length) {
    articleHeaders.forEach(headerLink => {
      headerLink.addEventListener('click', event => {
        event.preventDefault();
        const navItemSelector = event.target.getAttribute('href');
        const targetHeader = document.querySelector(navItemSelector);

        if (targetHeader) {
          window.scrollTo({
            top: targetHeader.getBoundingClientRect().top + window.scrollY - offset,
            behavior: 'smooth'
          });
        }
      });
    });

    window.addEventListener('scroll', () => {
      let currentActive = null;

      articleHeaders.forEach((link, index) => {
        const targetHeader = document.querySelector(link.getAttribute('href'));
        const nextHeader = articleHeaders[index + 1]
            ? document.querySelector(articleHeaders[index + 1].getAttribute('href'))
            : null;

        if (targetHeader) {
          const rect = targetHeader.getBoundingClientRect();
          const nextRect = nextHeader ? nextHeader.getBoundingClientRect() : null;

          if (rect.top - 90 <= offset && (!nextRect || nextRect.top > offset)) {
            currentActive = link;
          }
        }
      });

      articleHeaders.forEach(link => link.parentElement.classList.remove('active'));

      if (currentActive) {
        const activeParent = currentActive.parentElement;
        activeParent.classList.add('active');

        if (tocContainer) {
          const parentRect = activeParent.getBoundingClientRect();
          const containerRect = tocContainer.getBoundingClientRect();

          const isVisible =
              parentRect.top >= containerRect.top &&
              parentRect.bottom <= containerRect.bottom;

          if (!isVisible) {
            const scrollTop =
                activeParent.offsetTop -
                tocContainer.offsetTop -
                (tocContainer.clientHeight / 2) +
                (activeParent.offsetHeight / 2);

            tocContainer.scrollTo({
              top: scrollTop,
              behavior: 'smooth'
            });
          }
        }
      }
    });
  }
  // if (articleContent) {
  //   articleContent.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(header => {
  //     const level = parseInt(header.tagName.charAt(1), 10);
  //     const headerText = header.innerText;
  //     header.setAttribute('data-name', headerText);
  //     const listItem = document.createElement('li');
  //     const link = document.createElement('a');
  //     link.href = `#${headerText.replace(/\s+/g, '-').toLowerCase()}`;
  //     link.textContent = headerText;
  //     link.setAttribute('data-scroll', headerText);
  //
  //
  //     if (level === 1) {
  //
  //       listItem.appendChild(link);
  //       articleHeaders.appendChild(listItem);
  //     }
  //     if (level === 2) {
  //       const listItem = document.createElement('li');
  //       const list = document.createElement('ul');
  //       const listItemL2 = document.createElement('li');
  //       listItemL2.appendChild(link);
  //       list.appendChild(listItemL2);
  //       listItem.appendChild(list);
  //       articleHeaders.appendChild(listItem);
  //     }
  //     if (level === 3) {
  //       const listItem = document.createElement('li');
  //       const list = document.createElement('ul');
  //       const listItemL2 = document.createElement('li');
  //       const listItemL3 = document.createElement('li');
  //       const listL3 = document.createElement('ul');
  //       listItemL3.appendChild(link);
  //       listL3.appendChild(listItemL3);
  //       listItemL2.appendChild(listL3);
  //       list.appendChild(listItemL2);
  //       listItem.appendChild(list);
  //       articleHeaders.appendChild(listItem);
  //     }
  //     if (level === 4) {
  //       const listItem = document.createElement('li');
  //       const list = document.createElement('ul');
  //       const listItemL2 = document.createElement('li');
  //       const listItemL3 = document.createElement('li');
  //       const listItemL4 = document.createElement('li');
  //       const listL3 = document.createElement('ul');
  //       const listL4 = document.createElement('ul');
  //       listItemL4.appendChild(link);
  //       listL4.appendChild(listItemL4);
  //       listItemL3.appendChild(listL4);
  //       listL3.appendChild(listItemL3);
  //       listItemL2.appendChild(listL3);
  //       list.appendChild(listItemL2);
  //       listItem.appendChild(list);
  //       articleHeaders.appendChild(listItem);
  //     }
  //     if (level === 5) {
  //       const listItem = document.createElement('li');
  //       const list = document.createElement('ul');
  //       const listItemL2 = document.createElement('li');
  //       const listItemL3 = document.createElement('li');
  //       const listItemL4 = document.createElement('li');
  //       const listItemL5 = document.createElement('li');
  //       const listL3 = document.createElement('ul');
  //       const listL4 = document.createElement('ul');
  //       const listL5 = document.createElement('ul');
  //       listItemL5.appendChild(link);
  //       listL5.appendChild(listItemL5);
  //       listItemL4.appendChild(listL5);
  //       listL4.appendChild(listItemL4);
  //       listItemL3.appendChild(listL4);
  //       listL3.appendChild(listItemL3);
  //       listItemL2.appendChild(listL3);
  //
  //       list.appendChild(listItemL2);
  //       listItem.appendChild(list);
  //       articleHeaders.appendChild(listItem);
  //     }
  //     if (level === 6) {
  //       const listItem = document.createElement('li');
  //       const list = document.createElement('ul');
  //       const listItemL2 = document.createElement('li');
  //       const listItemL3 = document.createElement('li');
  //       const listItemL4 = document.createElement('li');
  //       const listItemL6 = document.createElement('li');
  //       const listItemL5 = document.createElement('li');
  //       const listL3 = document.createElement('ul');
  //       const listL4 = document.createElement('ul');
  //       const listL5 = document.createElement('ul');
  //       const listL6 = document.createElement('ul');
  //       listItemL6.appendChild(link);
  //
  //       listL6.appendChild(listItemL6);
  //       listItemL5.appendChild(listL6);
  //       listL5.appendChild(listItemL5);
  //       listItemL4.appendChild(listL5);
  //       listL4.appendChild(listItemL4);
  //       listItemL3.appendChild(listL4);
  //       listL3.appendChild(listItemL3);
  //       listItemL2.appendChild(listL3);
  //
  //       list.appendChild(listItemL2);
  //       listItem.appendChild(list);
  //       articleHeaders.appendChild(listItem);
  //     }
  //
  //
  //
  //
  //   });
  // }
  //   if (articleHeaders) {
  //   articleHeaders.addEventListener('click', event => {
  //     const target = event.target;
  //
  //     if (target.tagName === 'A') {
  //       const navItem = target.getAttribute('data-scroll');
  //       const targetHeader = articleContent.querySelector(`[data-name='${navItem}']`);
  //
  //       if (targetHeader) {
  //         window.scrollTo({
  //           top: targetHeader.getBoundingClientRect().top + window.scrollY - 90,
  //           behavior: 'smooth'
  //         });
  //       }
  //     }
  //   });
  // }
});
